import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  StyledSlider,
  StyledThumb,
  StyledTrack,
  CurrentValueText,
  NextButton,
} from "./slider.styles";

import CurrentQuestionContext from "../../../contexts/CurrentQuestionContext";

const STRING_VAL_LENGTH = 8;

const Slider = () => {
  const sliderSettings = useContext(CurrentQuestionContext).question
    .sliderSettings;
  const [currValue, setValue] = useState(sliderSettings.default);
  const [textBefore, setTextBefore] = useState("");
  const [isTouched, setIsTouched] = useState(false);
  const [textAfter, setTextAfter] = useState("");
  const setNextQuestion = useContext(CurrentQuestionContext).setNextQuestion;
  const currQuestionIndex = useContext(CurrentQuestionContext)
    .currQuestionIndex;
  let startTime = new Date();

  useEffect(() => {
    const { valueDisplayFormat } = sliderSettings;
    const valIndex = valueDisplayFormat.indexOf("${value}");
    const sliderTextWithoutValue = valueDisplayFormat.replace("${value}", "");
    const textLength = valueDisplayFormat.length;

    if (valIndex === 0) {
      setTextAfter(sliderTextWithoutValue);
    } else if (valIndex !== 0 && textLength > STRING_VAL_LENGTH + 1) {
      setTextBefore(valueDisplayFormat.slice(0, valIndex));
      setTextAfter(
        valueDisplayFormat.slice(valIndex + STRING_VAL_LENGTH, textLength)
      );
    } else {
      setTextBefore(sliderTextWithoutValue);
    }
  }, []);

  useEffect(() => {
    setIsTouched(false);
    setValue(sliderSettings.default);
  }, [currQuestionIndex]);

  const Thumb = (props, state) => (
    <StyledThumb {...props}>{state.valueNow}</StyledThumb>
  );

  const Track = (props, state) => (
    <StyledTrack {...props} index={state.index} />
  );

  return (
    <Container>
      <CurrentValueText>
        {textBefore}
        {currValue}
        {textAfter}
      </CurrentValueText>
      <StyledSlider
        renderTrack={Track}
        renderThumb={Thumb}
        invert={true}
        value={currValue}
        min={sliderSettings.min}
        max={sliderSettings.max}
        onChange={(value) => {
          setValue(value);
          setIsTouched(true);
        }}
      />
      <NextButton
        isDisabled={!isTouched}
        onClick={() => {
          isTouched && setNextQuestion(currValue, new Date() - startTime);
        }}
      >
        לשאלה הבאה
      </NextButton>
    </Container>
  );
};
export default Slider;
